<template>
  <div>
    <AppBar :name="$t('market.market')"></AppBar>
    <v-overlay v-show="isLoadUser" dark opacity="1" color="white">
      <v-progress-circular :value="20" color="green" indeterminate></v-progress-circular>
    </v-overlay>
    <div>
      <router-view v-if="!isLoadUser"></router-view>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import ParentBar from "../../components/ParentBar";
import MenuLeft from "../../components/MenuLeft";
import Footer from "../../components/Footer";
import AppBar from "../../components/AppBar";
import { mapGetters, mapState } from "vuex";
import i18n from '../../plugins/vue-i18n';
export default {
  components: {
    ParentBar,
    MenuLeft,
    Footer,
    AppBar
  },
  name: "Index",
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoadUser: true,
      disabledSSOBedrock: false
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/getUserInfo",
    }),
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins,
      sessionEmployees: state => state.employee.sessionEmployees
    })
  },
  async created() {
    try {
      this.isLoadUser = true
      await this.initUser()
      let projects = []
      let markets = []
      for (let admin of this.sessionAdmins) {
        if (admin.project?.objectId) projects.push(admin.project.objectId)
        if (admin.market?.objectId) markets.push(admin.market.objectId)
      }
      for (let employee of this.sessionEmployees) {
        if (employee.project?.objectId) projects.push(employee.project.objectId)
        if (employee.market?.objectId) markets.push(employee.market.objectId)
      }
      if (this.projectId && !projects.includes(this.projectId)) {
        this.$router.push(`/permissionDenied`);
        return
      } else {
        if (this.marketId && !markets.includes(this.marketId)) {
          this.$router.push(`/permissionDenied`);
          return
        }
      }
      if (this.marketId && !markets.find(id => id == this.marketId)) {
        this.$router.push(`/notFound`);
      }
      this.isLoadUser = false;
    } catch (err) {
      console.error(this.$t('error_loading_user_data')+':', err);
      this.isLoadUser = false;
      if (this.$route && this.$route.path) {
        this.$router.push("/auth/login?redirect=" + this.$route.path);
      } else {
        this.$router.push("/auth/login");
      }
    }
  },
  mounted() {
    i18n.locale = localStorage.getItem("selectedLanguage") || "th-TH"
  },
  methods: {
    async initUser() {
      await this.$store.dispatch("user/getUserInfo");
      let hashProject = {}
      for (let admin of this.sessionAdmins) {
        hashProject[admin.project.objectId] = admin.project
      }
      for (let employee of this.sessionEmployees) {
        hashProject[employee.project.objectId] = employee.project
      }
      if(this.userInfo.user && this.userInfo.user.locale){
        if (this.userInfo.user.locale == "la") {
          this.$moment.locale("lo")
          i18n.locale = "lo-LA"
        } else if (this.userInfo.user.locale == "us") {
          this.$moment.locale("en")
          i18n.locale = "en-US"
        } else {
          this.$moment.locale("th")
          i18n.locale = "th-TH"
        }
      }else if (hashProject) {
        let sortedUsers = Object.entries(hashProject).sort((a, b) => this.$moment(a[1].createdAt) - this.$moment(b[1].createdAt))
        if (sortedUsers?.length) {
          let project = sortedUsers[0][1]
          if (project?.locale == "la") {
            this.$moment.locale("lo")
            i18n.locale = "lo-LA"
          } else if (project?.locale == "us") {
            this.$moment.locale("en")
            i18n.locale = "en-US"
          } else {
            this.$moment.locale("th")
            i18n.locale = "th-TH"
          }
        }
      }
    }
  }
};
</script>

